import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import HcpSpecialityForm from './HcpSpecialityForm';

const HcpSpecialityModal = ({ show, onHide, specialityvalue, edittrigger, onCallParent }) => {
    const isEdit = specialityvalue && (specialityvalue.speciality_id || specialityvalue.id);

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit HCP Speciality' : 'Add HCP Speciality'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <HcpSpecialityForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    specialityvalue={specialityvalue}
                    hcpsplvalue={specialityvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

HcpSpecialityModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    specialityvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default HcpSpecialityModal;
